import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class UserSearchService {
  private API_APPLICATIONUSERS_SEARCH_URL = environment.API_URL + "api/users/find";

  constructor(private http: HttpClient) {}

  searchUser(request): Observable<any> {
    return this.http.post(this.API_APPLICATIONUSERS_SEARCH_URL, request);
  }
}
